import { AppUserSession } from "../user-session";
import { HookCreator } from "./apiHookCreators";

export const tokenSourceFn = AppUserSession.getToken.bind(AppUserSession);

export type ApiResponseType<PayloadType> = {
  payload: PayloadType;
  message: string;
};

export type IdParamType = {
  id: number;
};

export const { createGetApiHookCreator: createGetApiHook } = new HookCreator(
  "GET",
  tokenSourceFn,
);

export const { createUpdateApiHookCreator: createPostApiHook } =
  new HookCreator("POST", tokenSourceFn);

export const { createUpdateApiHookCreator: createPutApiHook } = new HookCreator(
  "PUT",
  tokenSourceFn,
);

export const { createUpdateApiHookCreator: createDeleteApiHook } =
  new HookCreator("DELETE", tokenSourceFn);

export const { createUpdateApiHookCreator: createPatchApiHook } =
  new HookCreator("PATCH", tokenSourceFn);
